import React from "react";
import { Link } from "react-router-dom";
import { Star, Quote, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <div data-testid="testimonials-page">
      <section className="bg-zinc-950 py-20 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[300px] bg-red-600/10 rounded-full blur-3xl" aria-hidden="true" />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] uppercase text-red-500 mb-4">
            <span className="w-8 h-[2px] bg-red-500 inline-block" /> Happy Clients
          </span>
          <h1 className="font-heading text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-5">
            Our <span className="text-red-500">Testimonials</span>
          </h1>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-amber-400 text-amber-400" />)}
            </div>
            <p className="text-zinc-400 text-sm font-semibold">5-star rated by our customers on Google</p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-zinc-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
            {TESTIMONIALS.map((t) => (
              <div key={t.id} className="break-inside-avoid bg-white rounded-xl border border-zinc-100 shadow-sm hover:shadow-lg transition-shadow duration-300 p-8" data-testid={`testimonial-item-${t.id}`}>
                <Quote size={28} className="text-red-600/30 mb-4" />
                <p className="text-sm text-zinc-700 leading-relaxed mb-6">{t.text}</p>
                <div className="flex items-center justify-between pt-4 border-t border-zinc-100">
                  <div>
                    <p className="font-heading font-bold text-zinc-900">{t.name}</p>
                    <p className="text-[11px] text-zinc-500 uppercase tracking-widest mt-0.5">{t.role}</p>
                  </div>
                  <div className="flex items-center gap-0.5">
                    {[...Array(t.rating)].map((_, i) => <Star key={i} size={13} className="fill-amber-400 text-amber-400" />)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <p className="text-zinc-600 mb-5 font-medium">Ready to experience it yourself?</p>
            <Button asChild size="lg" className="bg-red-600 hover:bg-red-700 text-white font-semibold uppercase tracking-wide text-sm h-14 px-9 rounded-md shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200" data-testid="testimonials-cta-btn">
              <Link to="/appointment">Make an Appointment <ArrowRight size={17} className="ml-1" /></Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
